// extracted by mini-css-extract-plugin
export default {"root":"EditListingListingQuoteDetailsPannel_root__e1nkb","form":"EditListingListingQuoteDetailsPannel_form__-LF0M","title":"EditListingListingQuoteDetailsPannel_title__u3TQs"};